import { SchemasValue } from "../../../services/api/instances/schemasApi/types";

export const getUpdatedSchemasValue = (
  value: SchemasValue,
  fields: Partial<SchemasValue["schemas_object"]> = {},
  metadata?: Partial<SchemasValue["metadata"]>,
): SchemasValue => ({
  schemas_object: {
    ...value.schemas_object,
    ...fields,
  },
  metadata:
    metadata !== undefined
      ? { ...value.metadata, ...metadata }
      : value.metadata,
});
